function handleJeepCase(marca) {
    let realMarcaValue = marca;
    if (typeof marca === 'string' && marca.includes('-')) {
        realMarcaValue = parseInt(marca.split('-')[0]);
    }
    return realMarcaValue
}

export default handleJeepCase;